<template>
  <div class="modalnobefore">
    <div class="flex-box">
      <div class="top">
        <span>选择日期：</span>
        <Date-picker style="width: 200px" type="date" v-model="date" placeholder="选择日期" format="yyyy-MM-dd"></Date-picker>
      </div>
      <Button type="ghost" @click="rept" class="btn-width" :style="{ width: '90px' }">重置</Button>
      <Button type="primary" @click="ok" class="btn-width" :style="{ width: '90px' }">查询</Button>
    </div>
    <div class="content-box">
      <div id="containerqz" class="content-l">
        <div class="map-legend" v-if="lineArr.length">
          <span><i class="dot dot-start"></i>起点</span>
          <span><i class="dot dot-end"></i>终点</span>
          <span><i class="arrow-sample">▶</i>行进方向</span>
          <span v-if="roadCorrected" class="tag-corrected">已道路纠偏</span>
        </div>
      </div>
      <div class="content-r">
        <div class="r-title">
          员工轨迹上报
          <span class="refresh" @click="getList">刷新</span>
          <span class="refresh" @click="back">返回</span>
        </div>
        <ul class="content">
          <li>
            <p>
              <span class="r-name" @click="startAnimation()">{{ dataInfo.userName }}</span>
              <span style="margin-left: 20px; color: green; font-weight: bold">状态:定位成功</span>
            </p>
            <p class="opt-row">
              <span style="font-weight: bold">道路纠偏：</span>
              <i-switch v-model="roadCorrectEnabled" size="small" @on-change="onRoadCorrectToggle" />
              <span class="opt-hint">贴合道路，减少穿河/穿楼</span>
            </p>
            <p><span style="font-weight: bold">部门：</span>{{ dataInfo.department }}</p>
            <p><span style="font-weight: bold">工号：</span>{{ dataInfo.gonghao }}</p>
            <p><span style="font-weight: bold">所属片区：</span>{{ dataInfo.area }}</p>
            <p><span style="font-weight: bold">打卡时间：</span>{{ dataInfo.dakashijian }}</p>
            <p><span style="font-weight: bold">最新定位时间：</span>{{ dataInfo.shujushijian }}</p>
            <p><span style="font-weight: bold">行走距离：</span>{{ dataInfo.xingzoujuli }}米</p>
            <p><span style="font-weight: bold">最后位置：</span>{{ dataInfo.zuihouweizhi }}</p>
            <p v-if="dataInfo.pointCount != null">
              <span style="font-weight: bold">轨迹点数：</span>{{ dataInfo.pointCount }}
              <span v-if="dataInfo.rawPointCount > dataInfo.pointCount" style="color: #888; margin-left: 8px">
                (已过滤 {{ dataInfo.rawPointCount - dataInfo.pointCount }} 个异常点)
              </span>
            </p>
            <p>轨迹状态：<span :style="{ color: dataInfo.isError == true ? 'green' : 'red', fontWeight: 'bold' }">{{ dataInfo.isError == true ? '正常' : '异常' }}</span></p>
            <p class="tip-text">点击姓名可回放轨迹；蓝色箭头表示行进方向</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import person from '@/assets/person1.png';
import { getOnlyTrajectory, getUserTrajectory } from '../../api/trajectory';
import { formatDateTime } from 'utils/format';
import {
  parseTrajectoryPath,
  parseRegionPaths,
  buildSegmentDurations,
  correctPathWithGraspRoad,
  calcBearing,
  pickDirectionAnchorIndices,
} from '@/utils/trajectoryMap';

export default {
  data() {
    return {
      date: this.$route.query.time || new Date(),
      person,
      personCode: this.$route.query.id,
      dataInfo: {},
      dataList: [],
      map: null,
      rawLineArr: [],
      lineArr: [],
      trajectTimes: [],
      trajectSpeeds: [],
      segmentDurations: 2000,
      roadCorrectEnabled: true,
      roadCorrected: false,
      markerT: null,
      polyline: null,
      rawPolyline: null,
      passedPolyline: null,
      startMarker: null,
      endMarker: null,
      directionMarkers: [],
      regionPolygons: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    format(data, showTime = true) {
      if (!data) return '';
      return formatDateTime(data, showTime);
    },
    ok() {
      this.getList();
    },
    back() {
      this.$router.push({ path: '/app/trajectorymonitor' });
    },
    rept() {
      this.date = '';
    },
    onRoadCorrectToggle() {
      if (this.rawLineArr.length) {
        this.applyPathAndRender();
      }
    },
    clearTrajectoryOverlays() {
      const toRemove = [
        this.markerT,
        this.polyline,
        this.rawPolyline,
        this.passedPolyline,
        this.startMarker,
        this.endMarker,
        ...this.directionMarkers,
      ].filter(Boolean);
      if (toRemove.length) this.map.remove(toRemove);
      this.markerT = null;
      this.polyline = null;
      this.rawPolyline = null;
      this.passedPolyline = null;
      this.startMarker = null;
      this.endMarker = null;
      this.directionMarkers = [];
    },
    async applyPathAndRender() {
      this.clearTrajectoryOverlays();
      let displayPath = this.rawLineArr;
      this.roadCorrected = false;
      if (this.roadCorrectEnabled && this.rawLineArr.length >= 2) {
        const { path, corrected } = await correctPathWithGraspRoad(
          this.rawLineArr,
          this.trajectTimes,
          this.trajectSpeeds
        );
        if (corrected && path.length >= 2) {
          displayPath = path;
          this.roadCorrected = true;
        }
      }
      this.lineArr = displayPath;
      if (this.lineArr.length > 0) {
        this.renderTrajectory();
      }
    },
    getList() {
      getOnlyTrajectory({
        clockPersonCode: [this.personCode],
        clockDate: this.date,
      })
        .then(async (res) => {
          if (!res.data) return;
          this.dataInfo.userName = res.data.userName;
          this.dataInfo.department = res.data.dept;
          this.dataInfo.gonghao = res.data.systemCode;
          this.dataInfo.area = res.data.trade;
          this.dataInfo.dakashijian = res.data.clockinDate;
          this.dataInfo.shujushijian = this.format(res.data.lastUploadData);
          this.dataInfo.xingzoujuli = res.data.walkDistance;
          this.dataInfo.zuihouweizhi = res.data.lastPlace;
          this.dataInfo.isError = res.data.unusualData;
          this.dataInfo.pointCount = res.data.pointCount;
          this.dataInfo.rawPointCount = res.data.rawPointCount;
          this.rawLineArr = parseTrajectoryPath(res.data.traject);
          this.trajectTimes = res.data.trajectTimes || [];
          this.trajectSpeeds = res.data.trajectSpeeds || [];
          this.segmentDurations = buildSegmentDurations(this.trajectTimes);
          await this.applyPathAndRender();
        })
        .catch(() => {});
    },
    init() {
      this.map = new AMap.Map('containerqz', {
        center: [116.400274, 39.905812],
        zoom: 14,
      });
      this.map.clearMap();
      AMap.plugin('AMap.ToolBar', () => {
        this.map.addControl(new AMap.ToolBar());
      });
      this.getRegion();
      this.getList();
    },
    clearRegionPolygons() {
      if (this.regionPolygons.length) {
        this.map.remove(this.regionPolygons);
        this.regionPolygons = [];
      }
    },
    getRegion() {
      getUserTrajectory({ clockPersonCode: [this.personCode] })
        .then((res) => {
          if (!res.data) return;
          this.clearRegionPolygons();
          parseRegionPaths(res.data.path).forEach((ring) => {
            if (!ring.length) return;
            const polygon = new AMap.Polygon({
              path: ring,
              strokeColor: 'blue',
              strokeStyle: 'dashed',
              fillOpacity: 0.4,
              fillColor: '#1791fc',
              zIndex: 50,
            });
            this.regionPolygons.push(polygon);
            this.map.add(polygon);
          });
        })
        .catch(() => {});
    },
    addEndpointMarkers() {
      const start = this.lineArr[0];
      const end = this.lineArr[this.lineArr.length - 1];
      this.startMarker = new AMap.Marker({
        map: this.map,
        position: start,
        zIndex: 200,
        offset: new AMap.Pixel(-14, -14),
        content: '<div class="traj-pin traj-pin-start">起</div>',
      });
      this.endMarker = new AMap.Marker({
        map: this.map,
        position: end,
        zIndex: 200,
        offset: new AMap.Pixel(-14, -14),
        content: '<div class="traj-pin traj-pin-end">终</div>',
      });
    },
    addDirectionMarkers() {
      const indices = pickDirectionAnchorIndices(this.lineArr, 100);
      indices.forEach((idx) => {
        if (idx <= 0 || idx >= this.lineArr.length) return;
        const bearing = calcBearing(this.lineArr[idx - 1], this.lineArr[idx]);
        const marker = new AMap.Marker({
          map: this.map,
          position: this.lineArr[idx],
          zIndex: 150,
          offset: new AMap.Pixel(-8, -8),
          content: `<div class="traj-arrow" style="transform:rotate(${bearing}deg)">▶</div>`,
        });
        this.directionMarkers.push(marker);
      });
    },
    renderTrajectory() {
      if (!this.lineArr.length) return;
      if (this.roadCorrectEnabled && !this.roadCorrected && this.rawLineArr.length >= 2) {
        this.rawPolyline = new AMap.Polyline({
          map: this.map,
          path: this.rawLineArr,
          strokeColor: '#bbb',
          strokeWeight: 3,
          strokeStyle: 'dashed',
          strokeOpacity: 0.55,
          zIndex: 40,
        });
      }
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        dirColor: '#ffffff',
        strokeColor: '#1890ff',
        strokeWeight: 6,
        borderWeight: 1,
        outlineColor: '#0d47a1',
        isOutline: true,
        lineJoin: 'round',
        lineCap: 'round',
        zIndex: 100,
      });
      this.addEndpointMarkers();
      this.addDirectionMarkers();
      AMap.plugin('AMap.MoveAnimation', () => {
        this.markerT = new AMap.Marker({
          map: this.map,
          position: this.lineArr[0],
          icon: this.person,
          offset: new AMap.Pixel(-13, -26),
          zIndex: 180,
        });
        this.passedPolyline = new AMap.Polyline({
          map: this.map,
          strokeColor: '#52c41a',
          strokeWeight: 5,
          lineJoin: 'round',
          lineCap: 'round',
          zIndex: 110,
        });
        this.markerT.on('moving', (e) => {
          this.passedPolyline.setPath(e.passedPath);
        });
        const fitTargets = [this.polyline, this.startMarker, this.endMarker];
        if (this.rawPolyline) fitTargets.push(this.rawPolyline);
        this.map.setFitView(fitTargets, false, [60, 60, 60, 60]);
      });
    },
    startAnimation() {
      if (!this.markerT || this.lineArr.length < 2) return;
      const opts = { autoRotation: true };
      opts.duration = Array.isArray(this.segmentDurations)
        ? this.segmentDurations
        : this.segmentDurations;
      if (opts.duration.length !== this.lineArr.length - 1) {
        opts.duration = 2000;
      }
      this.markerT.moveAlong(this.lineArr, opts);
    },
    getMarke() {},
  },
};
</script>

<style lang="less" scoped>
.modalnobefore {
  padding: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.flex-box {
  display: flex;
  margin-bottom: 24px;
  & > div {
    flex: auto;
    display: flex;
    margin-right: 20px;
    span {
      display: flex;
      width: auto;
      line-height: 30px;
    }
  }
}
.content-box {
  flex: 1;
  display: flex;
  .content-l {
    width: 70%;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    position: relative;
  }
  .content-r {
    flex: auto;
    .r-title {
      background: #649dd6;
      color: #fff;
      padding-left: 20px;
      height: 30px;
      line-height: 30px;
      .refresh {
        color: #fff;
        cursor: pointer;
        float: right;
        margin-right: 20px;
      }
    }
    .content {
      padding: 20px;
      li p {
        min-height: 30px;
        line-height: 30px;
        .r-name {
          font-weight: bold;
          color: green;
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .opt-row {
        display: flex;
        align-items: center;
        gap: 8px;
      }
      .opt-hint {
        color: #888;
        font-size: 12px;
      }
      .tip-text {
        color: #888;
        font-size: 12px;
        line-height: 22px;
      }
    }
  }
}
.map-legend {
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 300;
  background: rgba(255, 255, 255, 0.92);
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  span {
    margin-right: 14px;
    display: inline-flex;
    align-items: center;
  }
  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-right: 4px;
    display: inline-block;
  }
  .dot-start {
    background: #52c41a;
  }
  .dot-end {
    background: #f5222d;
  }
  .arrow-sample {
    color: #ff6600;
    font-style: normal;
    margin-right: 4px;
  }
  .tag-corrected {
    color: #1890ff;
    font-weight: bold;
    margin-right: 0;
  }
}
</style>

<style lang="less">
.traj-pin {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}
.traj-pin-start {
  background: #52c41a;
  border: 2px solid #fff;
}
.traj-pin-end {
  background: #f5222d;
  border: 2px solid #fff;
}
.traj-arrow {
  color: #ff6600;
  font-size: 16px;
  line-height: 16px;
  text-shadow: 0 0 2px #fff, 0 0 4px #fff;
  font-weight: bold;
}
</style>
